import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useEventCacheContext } from '../../contexts/EventCacheContext';
import CohostPage from './CohostPage';
import { IUEvent } from '../../lib/event';
import { addCohost, invalidateCohostLink } from '../../api/ElkEventService';
import { useUserContext } from '../../contexts/UserContext';

import { TAppElkEventId, TAppElkInvitee } from 'TProtocol/prototypes/events/messages';
import { useModalContext } from '../../contexts/ModalContext';
import Modal from '../../components/modals/Modal';

const CohostEventPage = () => {
  const navigate = useNavigate();
  const { eventId } = useParams();

  const userContext = useUserContext();
  const eventCacheContext = useEventCacheContext();
  const modalContext = useModalContext();

  const [showCopiedLinkTooltip, setShowCopiedLinkTooltip] = useState<boolean>(false);

  const event = eventId !== undefined ? eventCacheContext.getEvent(eventId) : undefined;

  useEffect(() => {
    if (eventId !== undefined) {
      void fetchEvent(eventId);
    }
  }, [eventId]);

  useEffect(() => {
    if (showCopiedLinkTooltip) {
      const timerId = setTimeout(() => {
        setShowCopiedLinkTooltip(false);
      }, 2000);
      return () => {
        clearTimeout(timerId);
      };
    }
    return () => {
      // noop
    };
  }, [showCopiedLinkTooltip]);

  const fetchEvent = async (eventId: string) => {
    const event = await eventCacheContext.fetchEvent({ eventId });
    if (event === undefined || !event.isHost) {
      navigate(`/event/${eventId}`);
    }
  };

  const onBackClick = () => {
    navigate(`/event/${eventId}`);
  };

  const onLinkClick = async () => {
    if (event === undefined) {
      return;
    }

    let link = event.cohostLink;
    if (event.cohostLink === undefined) {
      link = await eventCacheContext.refreshCohostLink(event.id);
    }

    if (link !== undefined) {
      void navigator.clipboard.writeText(link);
      setShowCopiedLinkTooltip(true);
    }
  };

  const onInvalidateClick = async () => {
    modalContext.show({
      contents: <Modal title="Delete Invitee"
                       subtitle="Are you sure you want to invalidate the existing cohost invite link?"
                       primaryButtonLabel="Yes" secondaryButtonLabel="No"
                       onPrimaryClick={onInvalidate}
                       onSecondaryClick={modalContext.hide}
                       useSystemColors={true}/>
    });
  };

  const onInvalidate = async () => {
    if (event !== undefined) {
      const response = await invalidateCohostLink(userContext, new TAppElkEventId({ eventId: event.id }));
      event.cohostLink = response.newLink;
      modalContext.hide();
    }
  };

  const onUpdate = async (event: IUEvent, invitee: TAppElkInvitee) => {
    eventCacheContext.setEvent(event);

    await addCohost(userContext, invitee, new TAppElkEventId({ eventId: event.id }));
  }

  return <CohostPage
    event={event}
    onBackClick={onBackClick}
    onUpdate={onUpdate}
    onLinkClick={onLinkClick}
    onInvalidateClick={onInvalidateClick}
    showCopiedLinkTooptip={showCopiedLinkTooltip}
  />
};

export default CohostEventPage;
